// Market kinds
export const MARKET_KIND_MATCH_RESULT = 'MatchResult';
export const MARKET_KIND_DOUBLE_CHANCE = 'DoubleChance';
export const MARKET_KIND_MATCH_RESULT_AND_BOTH_TEAMS_TO_SCORE = 'MatchResultAndBothTeamsToScore';
export const MARKET_KIND_BOTH_TEAMS_TO_SCORE = 'BothTeamsToScore';
export const MARKET_KIND_UNDER_OVER_4_POINTS_TOTAL_GOALS = 'UnderOver4Point5TotalGoals';
export const MARKET_KIND_UNDER_OVER_3_POINTS_5_TOTAL_GOALS = 'UnderOver3Point5TotalGoals';
export const MARKET_KIND_UNDER_OVER_2_POINTS_5_TOTAL_GOALS = 'UnderOver2Point5TotalGoals';
export const MARKET_KIND_UNDER_OVER_1_POINTS_5_TOTAL_GOALS = 'UnderOver1Point5TotalGoals';
export const MARKET_KIND_EXACT_GOALS = 'ExactGoals';
export const MARKET_KIND_TOTAL_GOALS_1_TO_2 = 'TotalGoals1To2';
export const MARKET_KIND_TOTAL_GOALS_1_TO_3 = 'TotalGoals1To3';
export const MARKET_KIND_TOTAL_GOALS_1_TO_4 = 'TotalGoals1To4';
export const MARKET_KIND_TOTAL_GOALS_2_TO_4 = 'TotalGoals2To4';
export const MARKET_KIND_TOTAL_GOALS_2_TO_3 = 'TotalGoals2To3';
export const MARKET_KIND_CORRECT_SCORE = 'CorrectScore';
export const MARKET_KIND_MATCH_RESULT_AND_UNDER_OVER_2_POINTS_5_TOTAL_GOALS =
	'MatchResultAndUnderOver2Point5TotalGoals';
export const MARKET_KIND_MATCH_RESULT_AND_UNDER_OVCER_1_POINTS_5_TOTAL_GOALS =
	'MatchResultAndUnderOver1Point5TotalGoals';
export const MARKET_KIND_AWAY_TEAM_EXACT_GOALS = 'AwayTeamExactGoals';
export const MARKET_KIND_HOME_TEAM_EXACT_GOALS = 'HomeTeamExactGoals';
export const MARKET_KIND_UNDER_OVER_1_POINTS_5_AWAY_TEAM_GOALS = 'UnderOver1Point5AwayTeamGoals';
export const MARKET_KIND_UNDER_OVER_1_POINT_5_HOME_TEAM_GOALS = 'UnderOver1Point5HomeTeamGoals';

// Selection types
export const SELECTION_TYPE_HOME_PLUS_GOAL = '1+G';
export const SELECTION_TYPE_HOME_PLUS_NO_GOAL = '1+NG';
export const SELECTION_TYPE_DRAW_PLUS_GOAL = 'X+G';
export const SELECTION_TYPE_DRAW_PLUS_NO_GOAL = 'X+NG';
export const SELECTION_TYPE_AWAY_PLUS_GOAL = '2+G';
export const SELECTION_TYPE_AWAY_PLUS_NO_GOAL = '2+NG';

export const SELECTION_TYPE_YES = 'YES';
export const SELECTION_TYPE_NO = 'NO';
export const SELECTION_TYPE_ZERO = '0';
export const SELECTION_TYPE_ONE = '1';
export const SELECTION_TYPE_OVER = 'O';
export const SELECTION_TYPE_UNDER = 'U';
export const SELECTION_TYPE_GOAL = 'G';
export const SELECTION_TYPE_NO_GOAL = 'NG';

// Redux highlight-games scope
export const REDUCER_NAME = 'sportsbookHighlightGames';
export const ACTION_PREFIX = '@komigen/highlightgames';
export const HIGHLIGHT_GAMES_BASE_URL = '/highlight-games-api';

// Other
export const WEEK_STATUS_PENDING = 'Pending';
export const WEEK_STATUS_PREAMBLE = 'Preamble';
export const WEEK_STATUS_BETTINGCLOSED = 'BettingClosed';
export const WEEK_STATUS_DATASTORED = 'DataStored';
export const WEEK_STATUS_STARTED = 'Started';
export const WEEK_STATUS_ENDED = 'Ended';

export const PENDING_BET_STATE_PENDING = 'Pending';
export const PENDING_BET_STATE_SENDING = 'Sending';
export const PENDING_BET_STATE_PLACED = 'Placed';

export const BETSLIP_VALIDATION_LOW_BALANCE = 'LowBalance';
export const BETSLIP_VALIDATION_UNKNOWN_ERROR = 'UnknownError';
export const BETSLIP_VALIDATION_ZERO_AMOUNT = 'ZeroAmount';
export const BETSLIP_VALIDATION_TAXATION_INFORMATION = 'TaxationInformation';
export const BETSLIP_VALIDATION_UNAUTHENTICATED = 'Unauthenticated';
export const BETSLIP_VALIDATION_SAME_EVENT_COMBO = 'SameEventInCombo';
export const BETSLIP_VALIDATION_ONE_LINE_COMBO = 'OneLineCombo';
export const BETSLIP_VALIDATION_POSSIBLE_WIN_LOWER_THAN_AMOUNT = 'PossibleWinLowerThanAmount';

export const SCHEDULE_STATUS_OFFLINE = 'Offline';
export const SCHEDULE_STATUS_INIT = 'Init';
export const SCHEDULE_STATUS_IN_BETWEEN = 'InBetween';

export const BET_HISTORY_STATUS_PENDING = 0;
export const BET_HISTORY_STATUS_WIN = 1;
export const BET_HISTORY_STATUS_LOSS = 2;
export const BET_HISTORY_STATUS_VOID = -1;

export const BET_HISTORY_PAGE_SIZE = 20;

export const BUNDLE_LAYOUT_VERTICAL = 'vertical';
export const BUNDLE_LAYOUT_HORIZONTAL = 'horizontal';
export const BUNDLE_LAYOUT_FLOATING = 'floating';

// Resource keys
export const RESOURCE_KEY_ONBOARDING_IMAGE_1 = 'HIGHLIGHT_GAMES_ONBOARDING_IMAGE_1';
export const RESOURCE_KEY_ONBOARDING_IMAGE_2 = 'HIGHLIGHT_GAMES_ONBOARDING_IMAGE_2';
export const RESOURCE_KEY_ONBOARDING_IMAGE_3 = 'HIGHLIGHT_GAMES_ONBOARDING_IMAGE_3';
export const RESOURCE_KEY_ONBOARDING_IMAGE_4 = 'HIGHLIGHT_GAMES_ONBOARDING_IMAGE_4';

export const RESOURCE_KEYS = [
	RESOURCE_KEY_ONBOARDING_IMAGE_1,
	RESOURCE_KEY_ONBOARDING_IMAGE_2,
	RESOURCE_KEY_ONBOARDING_IMAGE_3,
	RESOURCE_KEY_ONBOARDING_IMAGE_4
];

export const BET_AMOUNT_TAXATION_RULE_TYPE = 'BET_AMOUNT';
export const WIN_OVER_LIMIT_TAXATION_RULE_TYPE = 'WIN_OVER_LIMIT';

export const BETSLIP_TAB_SINGLE = 'BETSLIP_TAB_SINGLE';
export const BETSLIP_TAB_COMBO = 'BETSLIP_TAB_COMBO';

// API
export const RESPONSE_STATUS_UNAUTHORIZED = 'UNAUTHORIZED'; // 401

// UI
export const UI_BETSLIP_WRAPPER_ID = 'highlight-games-betslip-wrapper';
